var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"refwarningmain",staticClass:"rank-main"},[_c('div',{staticClass:"rank-title"},[_vm._v("近三个月预警次数排名前十")]),_c('Table',{attrs:{"height":_vm.tableHeight,"columns":_vm.columnsrank,"data":_vm.ranklist}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }